import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaCalendarAlt, FaArrowRight } from "react-icons/fa";

import baseUrl from "../components/baseurl";

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await axios.get(`${baseUrl}/blogget`);
        setBlogPosts(response.data.slice(0, 4));
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
        setIsLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const extractTextFromHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  return (
    <div className="container mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-indigo-900 mb-4">
          Latest Articles
        </h2>
        <div className="h-1 w-24 bg-indigo-500 mx-auto"></div>
        <p className="mt-6 text-gray-600 max-w-2xl mx-auto">
          Insights, tutorials, and thoughts on web development and technology.
        </p>
      </div>

      <div>
        {isLoading ? (
          <div className="flex items-center justify-center p-16">
            <div className="relative">
              <div className="h-16 w-16 rounded-full border-t-4 border-b-4 border-indigo-500 animate-spin"></div>
              <div className="absolute top-0 left-0 h-16 w-16 rounded-full border-t-4 border-b-4 border-indigo-200 animate-spin animate-pulse"></div>
            </div>
          </div>
        ) : (
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              {blogPosts.map((post) => (
                <Link
                  key={post._id}
                  to={`/blogpost/${post._id}/${post.title
                    ?.split(" ")
                    .join("-")}`}
                  className="group"
                >
                  <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 h-full flex flex-col">
                    <div className="relative overflow-hidden">
                      <img
                        className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-500"
                        src={post.imageUrl}
                        alt={post.title}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>

                    <div className="p-6 flex flex-col flex-grow">
                      <div className="flex items-center text-sm text-gray-500 mb-3">
                        <FaCalendarAlt className="mr-2" />
                        <span>{formatDate(post.createdAt)}</span>
                      </div>

                      <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-indigo-600 transition-colors duration-300">
                        {post.title}
                      </h3>

                      <p className="text-gray-600 mb-4 line-clamp-3">
                        {extractTextFromHtml(post.blogArticle)}
                      </p>

                      <div className="mt-auto pt-4 flex items-center text-indigo-600 font-medium group-hover:text-indigo-800 transition-colors duration-300">
                        Read More
                        <FaArrowRight className="ml-2 transform group-hover:translate-x-2 transition-transform duration-300" />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-12">
              <Link
                className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-300 inline-flex items-center"
                to="/blog"
              >
                View All Articles
                <FaArrowRight className="ml-2" />
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
